
export { useDevice } from "/codebuild/output/src933875154/src/dgbet/src/contexts/device/index.tsx"